import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="prompt-key-field"
// Reveals a free text field on the admin new prompt form when the operator picks the
// "add a new key" option, so a brand new prompt key can be created without a code change.
export default class extends Controller {
  static targets = ["select", "newKey", "newKeyInput"]
  static values = { newOption: String }

  connect() {
    this.sync(false)
  }

  toggle() {
    this.sync(true)
  }

  sync(focusWhenShown) {
    const addingNewKey = this.selectTarget.value === this.newOptionValue

    this.newKeyTarget.classList.toggle("hidden", !addingNewKey)
    this.newKeyInputTarget.required = addingNewKey

    if (addingNewKey) {
      if (focusWhenShown) this.newKeyInputTarget.focus()
    } else {
      this.newKeyInputTarget.value = ""
    }
  }
}
